<mat-tab-group class="height-100">
  <mat-tab>
    <ng-template mat-tab-label><i class="material-icons">pie_chart</i> {{'dashboard.current' | translate}}</ng-template>
    <ng-template matTabContent>
      <app-current [organization]="organization"></app-current>
    </ng-template>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label><i class="material-icons">stacked_bar_chart</i> {{'dashboard.historical' | translate}}</ng-template>
    <ng-template matTabContent>
      <app-historical [organization]="organization"></app-historical>
    </ng-template>
  </mat-tab>
</mat-tab-group>
